import { isAddress } from '@ethersproject/address'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import { getShortPublicAddress } from '../utils/formatting'
import { getUserProfileRoute } from '../utils/routes'

const Anchor = styled.a`
  display: inline-block;
  color: inherit;
  transition: opacity 120ms ease, transform 120ms cubic-bezier(.2, 1, .3, 1);
  cursor: pointer;

  &:active {
    transform: translateY(2px) !important;
  }

  &:hover {
    transform: translateY(-1px);
  }
`

export const getUsernameLabel = username => {
  if (isAddress(username)) {
    return getShortPublicAddress(username)
  }

  return username
}

const UserLink = ({ username }) => {
  const label = getUsernameLabel(username)

  return (
    <span>
      <Link
        href={getUserProfileRoute({
          username
        })}
      >
        <Anchor>
          @{label}
        </Anchor>
      </Link>
    </span>
  )
}

export default UserLink
